import { render, staticRenderFns } from "./RegisterPassword.vue?vue&type=template&id=01e04cc2&"
import script from "./RegisterPassword.vue?vue&type=script&lang=ts&"
export * from "./RegisterPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports